export const { antd } = await import(`./${ngwConfig.locale}.inc.ts`);
